import {
  AvailableColorSchemas,
  ColorSchemaDescriptor,
  EvolutionColorSchema,
} from '../components/DeltaValueHeader/types';

const EVOLUTION_COLOR_SCHEMAS: Record<
  EvolutionColorSchema,
  {
    up: AvailableColorSchemas;
    down: AvailableColorSchemas;
    stable: AvailableColorSchemas;
  }
> = {
  'arrow-neutral': {
    down: 'grey-fg',
    stable: 'grey-fg',
    up: 'grey-fg',
  },
  'arrow-normal': {
    down: 'orange-fg',
    stable: 'grey-fg',
    up: 'green-fg',
  },
  'arrow-reversed': {
    down: 'green-fg',
    stable: 'grey-fg',
    up: 'orange-fg',
  },
  normal: {
    down: 'orange',
    stable: 'grey',
    up: 'blue',
  },
  reversed: {
    down: 'blue',
    stable: 'grey',
    up: 'orange',
  },
};

const COLOR_SCHEMAS: Record<AvailableColorSchemas, ColorSchemaDescriptor> = {
  blue: {
    arrow: 'blue.700',
    arrowBg: null,
    arrowBorder: 'blue.700',
    bg: 'blue.100',
  },
  'green-fg': {
    arrow: 'green.700',
    arrowBg: 'green.200',
    arrowBorder: 'green.200',
    bg: null,
  },
  grey: {
    arrow: 'grey.700',
    arrowBg: null,
    arrowBorder: 'grey.200',
    bg: 'grey.200',
  },
  'grey-fg': {
    arrow: 'grey.700',
    arrowBg: 'grey.200',
    arrowBorder: 'grey.200',
    bg: null,
  },
  orange: {
    arrow: 'orange.700',
    arrowBg: null,
    arrowBorder: 'orange.700',
    bg: 'orange.100',
  },
  'orange-fg': {
    arrow: 'orange.700',
    arrowBg: 'orange.100',
    arrowBorder: 'orange.100',
    bg: null,
  },
};

export function useGraphColorSchema({
  delta,
  evolutionColorSchema,
}: {
  evolutionColorSchema?: EvolutionColorSchema | null;
  delta: number | null;
}): ColorSchemaDescriptor {
  if (!evolutionColorSchema || delta === null) {
    return {
      arrow: 'black',
      arrowBg: 'white',
      arrowBorder: 'black',
      bg: 'white',
    };
  }

  let schema = EVOLUTION_COLOR_SCHEMAS[evolutionColorSchema].stable;

  if (delta > 0) {
    schema = EVOLUTION_COLOR_SCHEMAS[evolutionColorSchema].up;
  } else if (delta < 0) {
    schema = EVOLUTION_COLOR_SCHEMAS[evolutionColorSchema].down;
  }

  return COLOR_SCHEMAS[schema];
}
